import debounce from 'just-debounce-it';
import AbstractFilter from '../AbstractFilter';
import { FILTER_EVENT } from '../FilterEvent';
import { SEARCH_MANAGER_EVENT } from '../../../helpers/searchManagerEvent';

export default class GeoBoundsFilter extends AbstractFilter {
  constructor(...args) {
    super(...args);
    this.Map = null;
    this._values = [];
  }

  attachMapComponent(mapComponent) {
    if (typeof mapComponent !== 'object') {
      return;
    }
    this.Map = mapComponent;
    this.Map.on(SEARCH_MANAGER_EVENT.MAP_MOVED, debounce(this._changeHandler.bind(this), 500));
  }

  reset() {
    this._values = [];
    if (this.Map === null) {
      return;
    }
    this.Map._filterMode = false;
  }

  open() {}

  close() {}

  isMultiple() {
    return false;
  }

  _changeHandler(bounds) {
    this._values = [bounds];
    this.emit(FILTER_EVENT.CHANGED, { interactive: false });
    this.emit(FILTER_EVENT.AUTO_SUBMIT);
  }
}
